/**
 * Desktop presence from tool fires. The agent's shell and file work never
 * touch terminalStore (that is the USER's terminal), so the dock learns about
 * them here: Bash → terminal, file tools → files.
 */
import { useComputerStore } from '../computerStore';

const FILE_TOOLS = new Set(['Write', 'Edit', 'MultiEdit', 'Read', 'Glob', 'Grep']);

export function surfaceForToolName(toolName: string): 'terminal' | 'files' | null {
  if (toolName === 'Bash') return 'terminal';
  if (FILE_TOOLS.has(toolName)) return 'files';
  return null;
}

export function stampAgentToolSurface(taskId: string, toolName: string): void {
  const surface = surfaceForToolName(toolName);
  if (!surface) return;
  useComputerStore.getState().onAgentToolSurface(taskId, surface);
}

export function clearAgentSurfaceOnEnd(taskId: string): void {
  useComputerStore.getState().clearAgentSurface(taskId);
}
